const ChevronSlim = (props) => {
  return (
    <svg width="6" height="10" viewBox="0 0 6 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0.789391 9.52022L5.65186 5.33941C5.75652 5.24942 5.81522 5.12738 5.81522 5.0001C5.81522 4.87282 5.75652 4.75078 5.65186 4.66079L0.789391 0.47998L0 1.15871L4.46787 5.00024L0 8.84178L0.789391 9.52022Z" fill="currentColor"/>
    </svg>

  );
};

export default ChevronSlim;